












import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import ClientHome from "./client-home/home.vue";
import ClientNewHome from "./client-newhome/home.vue";
import AdminHoem from "./admin-home/home.vue";
class PageHomeRequest extends PageRequest {
  FilterText: string;
}
@Component({
  components: { ClientHome, AdminHoem,ClientNewHome },
})
export default class Homes extends AbpBase {
  pagerequest: PageHomeRequest = new PageHomeRequest();
  get userName() {
    return this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
  }
  created() {}
}
